export class PlayerStats {
    public wins = '';
    public losses = '';
}